import { getToken } from "./authHeaderService";
import { apiInstance } from "./axiosService";
import { convertObjToQueryParams } from "./commonHelper";

export const getAllCollegeRanking = (payload) => {
    return apiInstance.get("college/getAllCollegeRanking" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const createCollegeRanking = (payload) => {
    return apiInstance.post("college/createCollegeRanking", payload, { headers: getToken() });
};

export const deleteCollegeRankingById = (payload) => {
    return apiInstance.post("college/deleteCollegeRankingById", payload, { headers: getToken() });
};

export const getAllCollegeScholarships = (payload) => {
    return apiInstance.get("college/getAllCollegeScholarships" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const createCollegeScholarship = (payload) => {
    return apiInstance.post("college/createCollegeScholarship", payload, { headers: getToken() });
};

export const deleteCollegeScholarshipById = (payload) => {
    return apiInstance.post("college/deleteCollegeScholarshipById", payload, { headers: getToken() });
};

export const getAllCourseAndCollege = (payload) => {
    return apiInstance.get("college/getAllCourseAndCollege" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const createCourseAndCollege = (payload) => {
    return apiInstance.post("college/createCourseAndCollege", payload, { headers: getToken() });
};

export const deleteCollegeAndCourseById = (payload) => {
    return apiInstance.post("college/deleteCollegeAndCourseById", payload, { headers: getToken() });
};

export const getAllCollegeExam = (payload) => {
    return apiInstance.get("college/getAllCollegeExam" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const createCollegeExam = (payload) => {
    return apiInstance.post("college/createCollegeExam", payload, { headers: getToken() });
};

export const deleteCollegeExamById = (payload) => {
    return apiInstance.post("college/deleteCollegeExamById", payload, { headers: getToken() });
};

export const getAllCollegeCourseExam = (payload) => {
    return apiInstance.get("college/getAllCollegeCourseExam" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const createCollegeCourseExam = (payload) => {
    return apiInstance.post("college/createCollegeCourseExam", payload, { headers: getToken() });
};

export const deleteCollegeCourseExamById = (payload) => {
    return apiInstance.delete(`college/deleteCollegeCourseExamById/${payload?.id}`, { headers: getToken() });
};